import React, { useState } from "react";
import EstimatesMessage from '../estimates/estimatesMessage';
import MessageWithIcon from '../common/MessageWithIcon';
import { logUI } from "../../api/andyliticsApi";
import { Collapse } from 'reactstrap';


const DetailsCostMessaging = props => {
    const [showMessages, setShowMessages] = useState(false);
    const { benefitDetails, isSelfPay } = props;
    const bd = benefitDetails;
    const providerEnvironment = bd.providerInformation.environment;
    const selfPay = bd.isSelfPay;
    const InNetwork = !(bd.isInNetwork && bd.isInNetwork.toLowerCase() === 'false');
    const hasMultiplePayers = !(bd && bd.hasMultipleInsuranceApplied.toLowerCase() === "false");
    const isSameDOS = bd.environment && (bd.environment.toLowerCase() == ("ntx hospital" || "ctx hospital"));// Same Date Of Service
    const enablePreventativeCareMessage = window && window.serverData && window.serverData.data && window.serverData.data.enablePreventativeCareMessage;
    const preventativeCareProcedureCodes = enablePreventativeCareMessage && window && window.serverData && window.serverData.data && window.serverData.data.preventativeCareProcedureCodes ? window.serverData.data.preventativeCareProcedureCodes : null;
    const procedureCodes = enablePreventativeCareMessage && benefitDetails && benefitDetails.procedurePricingDetails ? benefitDetails.procedurePricingDetails.map(element => {
        return preventativeCareProcedureCodes ? preventativeCareProcedureCodes.split(',').indexOf(element.procedureCode) !== -1 : false
    }) : null;
    const showPreventativeCareMesg = procedureCodes ? procedureCodes.indexOf(true) !== -1 : false;

    console.info(`DetailsCostMessaging providerEnvironment ${providerEnvironment}`);
    const mesgStart = <>
        <p>{`
            This is a good faith estimate (“estimate”) of the charges for the above service(s) and is based on information known to us at this time and
             does not reflect consideration for complications, secondary conditions, and/or other unknown factors. This estimate does not include costs
             for third party providers, including additional items or services your provider or facility may recommend as part of the course of care that must be
             scheduled or requested separately. If during the visit, care is considered preventive or some services are not provided, your cost may be lower than the estimate.
             Although we try very hard to give accurate estimates, there are many things which influence the actual charges that we are unable to predict.
             As a result, the final billed charges may be more, or less, than the estimated charges and will be reflected on a final billing statement.
             This estimate is not a contract and does not require you to obtain the items or services identified.`}
        </p>
        <p>{`
            If you provided insurance information, you will receive your first statement after the insurance has paid and the remaining balance is your responsibility
             which is on average 45 to 90 days after your appointment or discharge date. If you have questions regarding your bill, please contact Customer Service at
             1-800-994-0371, Monday through Friday: 8:00AM to 5:00PM.`
        }</p>
    </>;
    let mesgSpecific = '';
    switch (providerEnvironment.toLowerCase()) {
        case "ctx hospital":
        case "ctx clinic":
            mesgSpecific = <>
                <p>{`
                    Your estimate reflects hospital and professional charges, such as charges for room, equipment use, supplies, and
                     services provided by the physician and hospital's staff.`
                }</p>
                <p>{`
                    If you are receiving services in an outpatient department of the Hospital, you could be responsible for two co-insurance amounts.
                     Co-insurance liabilities apply for the physician who provides professional services to you AND to the facility where services are received.
                     You would not be responsible for the co-insurance based on facility charges, if this facility was not a hospital outpatient department.
                     Total co-insurance liability for the professional component and the facility component combined are based on the average charges for routine services
                     provided in hospital outpatient departments. This is an estimate only.`
                }</p>
            </>;
            break;
        case "ntx hospital":
            mesgSpecific =
                <p>{`
                    Your estimate reflects only hospital charges, such as charges for room, equipment use, supplies, and services provided by the hospital's staff.
                     Our account does not include charges for your physician or any other physician fees, such as Emergency Room Physician, Radiologist, Anesthesiologist, Pathologist,
                     or other consulting physicians. These physician charges are billed separately and are your separate responsibility.`
                }</p>
            break;
        case "htpn":
        case "htpn clinic":
            mesgSpecific =
                <p>{`
                    Your estimate reflects only physician fees and does not include any hospital charges, such as charges for room, equipment use, supplies, and
                     services provided by the hospital's staff. These hospital charges are billed separately and are your separate responsibility.`
                }</p>
            break;
    }
    const mesgSelfPay = selfPay.toLowerCase() == "true"
        ? <p>{`
        If your actual billed charges are in excess of the charges included in this estimate, you have the right to dispute this bill.
         You may contact the health care provider or facility listed to let them know the billed charges are higher than the estimate.
         You can ask them to update the bill to match the estimate, ask to negotiate the bill, or ask if there is financial assistance available.
         You may also start a dispute resolution with the U.S. Department of Health and Human Services (HHS). If you choose to use the dispute resolution process,
         you must start the dispute process within 120 calendar days (about 4 months) of the date on the original bill.
         To learn more and get a form to start the process, go to `
        }
            <a href="https://www.cms.gov/nosurprises" target="_blank">www.cms.gov/nosurprises</a> or call <a href="tel:1-877-696-6775" className="phone-link">1-877-696-6775.</a>
        </p>
        : ``;

    const estimateMessage = <div><div>{mesgStart}</div><div>{mesgSpecific}</div><div>{mesgSelfPay}</div></div>;
    try {
        return <div className="col-12 col-xl-9 order-2 order-lg-3">
            <div onClick={() => setShowMessages(!showMessages)} className="row estimate-details-tile-message showDetails">
                <div className="col-12">{showMessages ? `HIDE` : `SHOW`} DETAILS <span className={showMessages ? "icon-dd-up" : "icon-dd"} /></div>
            </div>
            <Collapse isOpen={showMessages}>
                <div className={(isSelfPay ? "self-pay " : (InNetwork ? "in-network " : "out-network ")) + "row estimate-details-tile-message"}>
                    <div className="col-12">
                        <MessageWithIcon
                            icon={(isSelfPay ? "icon-list-check" : (InNetwork ? "icon-list-check" : "icon-input-error"))}
                        >
                            <span>
                                {isSelfPay ? 'You received a self-pay discount on this estimate.' :
                                    (InNetwork ? 'This service is considered IN-NETWORK.' :
                                        'This service is considered OUT-OF-NETWORK. There may be more cost effective options for you.')}
                            </span>
                        </MessageWithIcon>

                    </div>
                </div>
                {(hasMultiplePayers) &&
                    <div className="row estimate-details-tile-message">
                        <div className="col-12">
                            <MessageWithIcon icon="icon-info-filled">
                                <span>
                                    Due to having multiple insurances, your estimated amount due is $0. After the secondary insurance
                                    has paid its share, you may be responsible for any remaining amount that was not covered.{` `}
                                </span>

                            </MessageWithIcon>
                        </div>
                    </div>
                }
                {isSameDOS &&
                    <div className="row estimate-details-tile-message">
                        <div className="col-12">
                            <MessageWithIcon icon="icon-info-filled">
                                <span>
                                    Estimates for all appointments scheduled for the same service date are reflected in this estimate.
                                </span>
                            </MessageWithIcon>
                        </div>
                    </div>
                }
                {(showPreventativeCareMesg && !isSelfPay) &&
                    <div className="row estimate-details-tile-message">
                        <div className="col-12">
                            <MessageWithIcon icon="icon-info-filled">
                                <span>
                                    You are scheduled for an annual preventive exam, which most payers will cover at 100% with no patient out of pocket responsibility. If during the visit there are other concerns you would like to address, you may be responsible for additional charges.
                                </span>
                            </MessageWithIcon>
                        </div>
                    </div>
                }
                {(props.pricingCOVIDMessage && props.pricingCOVIDMessage.length > 0) &&
                    <div className="row  estimate-details-tile-message">
                        <div className="col-12">
                            <MessageWithIcon message={props.pricingCOVIDMessage} icon="icon-info-filled" />
                        </div>
                    </div>
                }
            </Collapse>
            <div className="row  estimate-details-tile-message">
                <div className="col-12">
                    <MessageWithIcon icon="icon-info-filled">
                        <span>Final costs are sometimes different from the estimate, are subject to change, and do not include costs for third party providers.{' '}<EstimatesMessage message={estimateMessage} target="final-cost" /> </span>
                    </MessageWithIcon>
                </div>
            </div>
        </div>;
    } catch (ex) {
        logUI("MBHWeb.UI.Estimates.detailsCostMessaging", new Date(), `estimateDetails/${props.csnId}`, props, 'ERROR', ex.message);
        return <React.Fragment>{ex}</React.Fragment>;
    }
}

export default DetailsCostMessaging;

